<header class="header">
  <div class="wrapper wrap">
      <a href="https://www.solihull.gov.uk/"><img class="header-logo"
      src="/assets/images/logo.png"
      alt="Solihull Metropolitan Borough Council" /></a>

  </div>
</header>